import { render, staticRenderFns } from "./organizationdata.vue?vue&type=template&id=207db8bc&scoped=true&"
import script from "./organizationdata.vue?vue&type=script&lang=js&"
export * from "./organizationdata.vue?vue&type=script&lang=js&"
import style0 from "./organizationdata.vue?vue&type=style&index=0&id=207db8bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207db8bc",
  null
  
)

export default component.exports